import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";

import { storeActions } from "../../../redux/actions";
import Topbar from "../../../shared/components/topbar/Topbar";
import Button from "../../../shared/components/Buttons/Button";
import {
  createCompanyDynamicUrl,
  getActionColumnOfReactDataTableComponent,
  isSpinnerEnabled,
} from "../../../shared/utility";
import SearchField from "../../../shared/components/searchField/SearchField";
import CustomTooltip from "../../../shared/components/toolTipComponent/CustomTooltip";
import ConfirmationModal from "../../Inventory/Items/ConfirmationModal/ConfirmationModal";
import DataTableComponent from "../../../shared/components/table/ReactDataTableComponent";
import DropdownSkeleton from "../../../shared/Skeletons/DropdownSkeleton/DropdownSkeleton";
import {
  storeConstants,
  routesPathConstants,
  buttonTypeConstants,
  buttonNameConstants,
  EMPTY_STRING,
  TABLE_IDS,
} from "../../../constants";
import {
  AddIcon,
  EditIcon,
  CrossIcon,
  DeleteIcon,
  SearchIcon,
  BlueBoxIcon,
  ActionDotsIcons,
} from "../../../assets/icons/iconsProvider";
import { TableCustomCellWrapper } from "../../../shared/components";

const defaultGridState = {
  pageSize: 50,
  pageIndex: 0,
  sortBy: [],
};
const Stores = (props) => {
  const { stores, getStores, spinnerArray } = props;
  const navigate = useNavigate();
  const [defaultSortFieldId, setDefaultSortFieldId] = useState();
  const [gridState, setGridState] = useState(defaultGridState);
  const [searchText, setSearchText] = useState("");
  let numOfRenders = useRef(0);
  let [storeToBeDeleted, setStoreToBeDeleted] = useState({
    isModalOpen: false,
    rowData: {},
  });
  //-------User reducer

  const handleEditClick = (row) => {
    navigate(createCompanyDynamicUrl(routesPathConstants.ADMIN_STORES_EDIT), {
      state: { ...row },
    });
  };

  const handleDeleteClick = (row) => {
    setStoreToBeDeleted({ isModalOpen: true, rowData: row });
    // props.deleteStore(row.id);
    // reset pagination
    numOfRenders.current++;
  };

  const [columns, setColumns] = useState([
    {
      id: "storeName",
      name: "Store Name",
      tooltopText: "Store Name",
      selector: (row) => row.storeName,
      cellValueKey: "storeName",
      sortable: true,
      sortDirection: null,
    },
    {
      id: "state",
      name: "State",
      selector: (row) => row.state,
      cellValueKey: "state",
      sortable: true,
      sortDirection: null,
    },
    {
      id: "city",
      name: "City",
      selector: (row) => row.city,
      cellValueKey: "city",
      sortable: true,
      sortDirection: null,
    },
    {
      id: "defaultTax",
      name: "Default Tax",
      tooltopText: "Default Tax",
      selector: (row) => row.defaultTax,
      cell: (row) => (
        <TableCustomCellWrapper row={row} cellValue={`${row.defaultTax} %`} />
      ),
      sortable: true,
      sortDirection: null,
    },
    {
      id: "phoneNumber",
      name: "Phone Number",
      selector: (row) => row.phoneNumber,
      cellValueKey: "phoneNumber",
      sortable: true,
      sortDirection: null,
    },
    {
      id: "returnPolicy",
      tooltopText: "Return Policy",
      name: "Return Policy",
      selector: (row) => row.returnPolicy,
      cellValueKey: "returnPolicy",
      sortable: true,
      sortDirection: null,
    },
    {
      id: "zip",
      name: "ZIP",
      selector: (row) => row?.zip ?? EMPTY_STRING,
      cellValueKey: "zip",
      sortable: true,
      sortDirection: null,
      width: "10%",
    },
    {
      id: "logo",
      name: "Logo",
      cell: (row) => (
        <TableCustomCellWrapper
          row={row}
          cellValue={
            row?.logo ? (
              <img src={row?.logo} className="logo-image-table" alt="logo" />
            ) : (
              "No Logo"
            )
          }
        />
      ),
      sortable: true,
      sortDirection: null,
    },
    {
      id: "line1",
      name: "Address",
      selector: (row) => row.line1,
      cellValueKey: "line1",
      sortable: true,
      sortDirection: null,
    },
    {
      id: "status",
      name: "Status",
      selector: (row) => row.isStoreActive,
      cell: (row) => (
        <TableCustomCellWrapper
          row={row}
          cellValue={
            row?.isStoreActive ? storeConstants.ACTIVE : storeConstants.INACTIVE
          }
        />
      ),
      sortable: true,
      sortDirection: null,
    },
    getActionColumnOfReactDataTableComponent((row) => {
      return (
        <>
          <CustomTooltip anchorSelect={`#tool${row.id}`}>
            <Button
              label={buttonNameConstants.EDIT}
              className="w-100"
              buttonType={buttonTypeConstants.ACTION_BUTTON}
              IconImage={EditIcon}
              handleClick={() => handleEditClick(row)}
            />
            <Button
              label={buttonNameConstants.DELETE}
              className="w-100"
              buttonType={buttonTypeConstants.ACTION_BUTTON}
              IconImage={DeleteIcon}
              handleClick={() => handleDeleteClick(row)}
            />
          </CustomTooltip>
          <button id={`tool${row.id}`} className="action-Button-Wrapper">
            <ActionDotsIcons className="cursor-pointer" />
          </button>
        </>
      );
    }),
  ]);
  const onTableSort = (column, sortDirection) => {
    setColumns(
      columns.map((col) => {
        if (col.id === column.id) {
          return {
            ...col,
            sortDirection,
          };
        } else {
          return {
            ...col,
            sortDirection: null,
          };
        }
      })
    );

    setDefaultSortFieldId(column.id);
  };
  const updateGridState = (newGridState) => {
    setGridState(newGridState);
  };
  //-------Handle searchfield change
  const handleFilterData = (e) => {
    const filterList = stores.filter((row) => {
      return (
        String(row.storeName + row.phoneNumber + row.city + row.zip)
          .toLowerCase()
          .includes(String(searchText).toLowerCase()) &&
        searchText !== EMPTY_STRING
      );
    });
    numOfRenders.current++;
    return filterList;
  };
  const clearSearchText = () => {
    setSearchText("");
  };
  useEffect(() => {
    getStores();
    // eslint-disable-next-line
  }, []);
  //-------Return Users Component
  return (
    <>
      <Topbar title="Stores"></Topbar>
      <Row className="m-0 w-100 px-0 user-screen-wrapper">
        {isSpinnerEnabled(spinnerArray, storeConstants.GET_STORES) ? (
          <>
            <Col md={5}>
              <DropdownSkeleton width={"100%"} />
            </Col>
            <Col md={3}></Col>
            <Col
              md={4}
              className="d-flex justify-content-end align-items-center  gap-3"
            >
              <DropdownSkeleton />
            </Col>
          </>
        ) : (
          <>
            <Col md={5}>
              <SearchField
                onChange={(e) => setSearchText(e.target.value)}
                IconImage={SearchIcon}
                label="Search"
                placeHolder="Type or Scan"
                value={searchText}
                CrossIcon={searchText ? CrossIcon : ""}
                clearSearchText={clearSearchText}
                BlueBoxIcon={BlueBoxIcon}
              />
            </Col>
            <Col md={3}></Col>
            <Col
              md={4}
              className="d-flex justify-content-end align-items-end  gap-3"
            >
              <Button
                label={buttonNameConstants.ADD}
                IconImage={AddIcon}
                handleClick={() =>
                  navigate(
                    createCompanyDynamicUrl(
                      routesPathConstants.ADMIN_STORES_ADD
                    )
                  )
                }
              />
            </Col>
          </>
        )}
      </Row>
      <Row className="m-0 w-100 h-100 user-screen-wrapper pt-3">
        {/* <ReactDataTable columnHeaders={columnHeaders} data={stores} /> */}
        <DataTableComponent
          columns={columns}
          onSort={onTableSort}
          gridState={gridState}
          resizableColumns={false}
          className="customers-table"
          key={numOfRenders.current}
          setGridState={updateGridState}
          tableId={TABLE_IDS.ADMIN_STORES}
          defaultSortFieldId={defaultSortFieldId}
          data={searchText ? handleFilterData() : [...stores].reverse()}
          total={searchText ? handleFilterData().length : stores?.length}
        />
      </Row>
      <ConfirmationModal
        isConfirmationModal={storeToBeDeleted.isModalOpen}
        handleNoButtonClick={() => {
          setStoreToBeDeleted({ ...storeToBeDeleted, isModalOpen: false });
        }}
        handleYesButtonClick={() => {
          setStoreToBeDeleted({ ...storeToBeDeleted, isModalOpen: false });
          props.deleteStore(storeToBeDeleted.rowData.id);
        }}
        message={
          <p className="px-2">
            Are you sure you want to permanently delete "
            {storeToBeDeleted.rowData?.storeName}" store and all of its data ?
            <br /> All of the inventory/transaction data and users/store-owners
            who only have access to this store will be deleted, along with all
            other store data.
          </p>
        }
      />
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  stores: state.store.stores,
  spinnerArray: state.system.spinnerArray,
  company: state.authentication.company,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getStores: () => dispatch(storeActions.getStores()),
  deleteStore: (storeId) => dispatch(storeActions.deleteStore(storeId)),
});

//-------Export AddNewUser Component
export default connect(mapStateToProps, mapDispatchToProps)(Stores);
